import { appHttpClient } from "../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../installations/http/inFlight";

const getBusinessCustomerList = () => {
  // 0016: dedupe StrictMode double-invoke (the useBusinessCustomerListQuery queryFn) into one request.
  return dedupeRequest("businessCustomers:all", () =>
    appHttpClient.get("/BusinessCustomer/List")
  );
};

// M3: slim, assignment-filtered customer list for the agent/admin on-behalf selector.
const getCustomersForAgent = () => {
  // 0016: dedupe StrictMode double-invoke (the useCustomersForAgentQuery queryFn) into one request.
  return dedupeRequest("businessCustomers:forAgent", () =>
    appHttpClient.get("/BusinessCustomer/ForAgent")
  );
};

const businessCustomerService = {
  getBusinessCustomerList,
  getCustomersForAgent,
};

export default businessCustomerService;
